import {
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import LogsTableContent from './LogsTableContent';
import LogsTableHead from './LogsTableHead';
import Loading from '../Loading/loading';
import LogsToolbar from './LogsToolbar';

export default function LogsTable({
  filteredData,
  fetchData,
  columnFields,
  tableName,
  pageSize,
  page,
  loading,
  searchTerm,
  handleFilterByName
}) {
  const cumulativeLogCount = page * pageSize;
  const noLogsAdded = !filteredData.length;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          {tableName}
        </Typography>
      </Stack>

      <Card>
        <LogsToolbar
          filterName={searchTerm}
          onFilterName={handleFilterByName}
        />
        <TableContainer sx={{ minWidth: 600 }}>
          {loading ? (
            <Loading />
          ) : (
            <Table>
              <LogsTableHead headLabel={columnFields} />
              <TableBody>
                {filteredData.map((row, index) => (
                  <LogsTableContent
                    key={row.id}
                    row={row}
                    columns={columnFields}
                    index={cumulativeLogCount + index}
                    fetchData={fetchData}
                    tableName={tableName}
                  />
                ))}
              </TableBody>

              {noLogsAdded && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No logs have been added yet
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
      </Card>
    </>
  );
}
